/**
 * Web-side shape of the public-state view returned by the worker. This
 * mirrors what `demoLanePlugin.publicState(state, viewer)` emits — kept
 * narrow because the web client doesn't need to know the full state ADT
 * (the engine is authoritative; the client only renders).
 */

export type ViewerPlayerState = {
  readonly mana: number;
  readonly hand: readonly string[];
  readonly deck: readonly string[];
};

export type OpponentPlayerState = {
  readonly mana: number;
  readonly handSize: number;
  readonly deckSize: number;
};

export type LaneView = {
  readonly units: Readonly<Record<string, readonly { cardId: string; power: number }[]>>;
  readonly controller: string | null;
};

export type PublicState = {
  readonly round: number;
  readonly players: Readonly<Record<string, ViewerPlayerState | OpponentPlayerState>>;
  readonly lanes: readonly LaneView[];
  readonly activePlayer: string;
};

export const isViewerState = (s: ViewerPlayerState | OpponentPlayerState): s is ViewerPlayerState =>
  'hand' in s && Array.isArray(s.hand);
